import React from "react";
import IntegrationAlfabankPage from "./IntegrationAlfabankPage";
import useIntegrationAlfabank from "./useIntegrationAlfabank";

function IntegrationAlfabank() {
  return <IntegrationAlfabankPage {...useIntegrationAlfabank()} />;
}

export default IntegrationAlfabank;
